// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectedItem_wrapper__rx7ov","col1":"SelectedItem_col1___oPuy","truncateText":"SelectedItem_truncateText__7qjwX","col3":"SelectedItem_col3__57hS3"};